function state() {
  return {
    endorsement: {},
    endorsements: [],
    endorsementsMeta: {},
    partners: [],
    productCategories: [],
  };
}

export default state;
